import { Box, Button, CardActions as CardActionsMUI } from '@mui/material'
import { useCallback, useContext } from 'react'
import { BUTTONS } from '../../Desktop/Tabla'
import { ITenant } from '../../../../AbmLocalPage/types'
import { TenantsContext } from '../../../../../context/tenants.context'

interface CardActionsProps {
  product: any
  isAdmin: boolean
  handleEditProduct: () => void
  handleResumeProduct: (code: string, name: string, tenant: ITenant) => void
  handlePauseProduct: (code: string, name: string, tenant: ITenant) => void
  handleDeleteProduct: (code: string, name: string, tenant: ITenant) => void
}

const CardActions = ({
  handleEditProduct,
  handleDeleteProduct,
  handlePauseProduct,
  handleResumeProduct,
  isAdmin,
  product
}: CardActionsProps) => {
  const { tenant } = useContext(TenantsContext)
  const handleDeleteClick = useCallback(() => {
    handleDeleteProduct(product.codProducto, product.nombre, tenant)
  }, [product.codProducto, handleDeleteProduct])

  return (
    <CardActionsMUI
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px'
      }}
    >
      <Box style={{ display: 'flex', flexDirection: 'row' }}>
        {product.vencido && (
          <Button variant="text" startIcon={BUTTONS.restore.icon} onClick={handleEditProduct}>
            {BUTTONS.restore.text}
          </Button>
        )}
        {product.pausado ? (
          <Button
            variant="text"
            startIcon={BUTTONS.resume.icon}
            onClick={() => handleResumeProduct(product.codProducto, product.nombre, tenant)}
          >
            {BUTTONS.resume.text}
          </Button>
        ) : (
          <Button
            variant="text"
            startIcon={BUTTONS.pause.icon}
            onClick={() => handlePauseProduct(product.codProducto, product.nombre, tenant)}
          >
            {BUTTONS.pause.text}
          </Button>
        )}

        {isAdmin && (
          <Button variant="text" startIcon={BUTTONS.approve.icon} onClick={() => BUTTONS.approve.action}>
            {BUTTONS.approve.text}
          </Button>
        )}

        <Button variant="text" startIcon={BUTTONS.delete.icon} onClick={handleDeleteClick} color="error">
          {BUTTONS.delete.text}
        </Button>
      </Box>
    </CardActionsMUI>
  )
}

export default CardActions
